import React, { RefObject } from 'react';
import { Draggable } from 'react-beautiful-dnd';

import Accommodation from './Accommodation';
import Activity from './Activity';
import Basic from './Basic';
import { ItemProps } from './common';
import Embed from './Embed';
import EventGroup from './EventGroup';
import Gif from './Gif';
import Headline from './Headline';
import styles from './index.scss';
import Livestream from './Livestream';
import Paragraph from './Paragraph';
import Person from './Person';
import Photo from './Photo';
import PhotoGallery from './PhotoGallery';
import PhotoTimeline from './PhotoTimeline';
import Question from './Question';
import DressCode from './DressCode';
import Transportation from './Transportation';

// TypeLookup doesn't contain a CoverPhotoPortraitItem property because
// <CoverPhotoPortrait /> should appear in LiteHomePage even if the coverphotoItem doesn't exist
const typeLookup: { [index: string]: React.FC<ItemProps> } = {
  AccommodationItem: Accommodation,
  ActivityItem: Activity,
  HeadlineItem: Headline,
  ParagraphItem: Paragraph,
  PersonItem: Person,
  StoryItem: Basic,
  BasicItem: Basic,
  TransportationItem: Transportation,
  PhotoItem: Photo,
  PhotoGalleryItem: PhotoGallery,
  PhotoTimelineItem: PhotoTimeline,
  EventGroupItem: EventGroup,
  GifItem: Gif,
  EmbedItem: Embed,
  QuestionItem: Question,
  DressCodeItem: DressCode,
  LivestreamItem: Livestream,
};

interface Props extends Omit<ItemProps, 'dragProps' | 'className'> {
  index: number;
  iframeRef?: RefObject<HTMLIFrameElement>;
  hideTitle?: boolean;
  onUpdate?: () => void;
}

const Item: React.FC<Props> = ({ item, page, index, preview = false, iframeRef, hideTitle, onUpdate = () => {} }) => {
  const Type = typeLookup[item.type];

  if (!Type) return null;

  return (
    <Draggable draggableId={`draggable-${item.id}`} index={index}>
      {(provider, snapshot) => {
        const dragProps = {
          innerRef: provider.innerRef,
          ...provider.draggableProps,
          ...provider.dragHandleProps,
        };

        return (
          <Type
            className={snapshot.isDragging ? styles.item : ''}
            item={item}
            page={page}
            dragProps={dragProps}
            preview={preview}
            iframeRef={iframeRef}
            hideTitle={hideTitle}
            {...(item.type === 'EventGroupItem' ? { onEventUpdate: onUpdate } : {})}
          />
        );
      }}
    </Draggable>
  );
};

export default Item;
